export default __webpack_public_path__ + "static/email-b5e7c4ee8721f2fb6da50fb2dfe2aaf3.png";